/**
 * 対戦トランスポート（自前・GPL非依存）。
 *
 * 同期方式は「権威者スナップショット（方式B）」。Transport は MsgChannel（ルーム単位の
 * 再ブロードキャスト・エコーなし）の薄いラッパで、チャンネル実装を差し替えるだけで
 * ローカル検証（BroadcastChannel）と遠隔対戦（PartyKit/WebSocket）の両方に対応する。
 *
 * 設計: knowledge/architecture/nineball-rules-engine.md §7。
 */

import type { NetMessage, Transport } from './transport.js';
import type { ChannelFactory, MsgChannel } from './channel.js';
import { broadcastChannelFactory } from './channel.js';

/** 1 試合のルーム名（バックエンド共通）。 */
const matchRoom = (room: string): string => `pool-net-${room}`;

/** 任意の MsgChannel 上に Transport を構築する（loopback / PartyKit 共通）。 */
export const createChannelTransport = (ch: MsgChannel<NetMessage>): Transport => ({
  send: (msg: NetMessage): void => ch.post(msg),
  onMessage: (cb: (msg: NetMessage) => void): void => ch.onMessage(cb),
  close: (): void => ch.close(),
});

/** チャンネルファクトリ（バックエンド）を指定して Transport を生成する。 */
export const createTransportWith = (
  factory: ChannelFactory,
  room: string,
): Transport => createChannelTransport(factory<NetMessage>(matchRoom(room)));

/** ループバック Transport（同一ブラウザの別タブ間・インフラ不要の検証用）。 */
export const createLoopbackTransport = (room: string): Transport =>
  createTransportWith(broadcastChannelFactory, room);
